export const entitiesFormatter = entity => {
  return {
    label: entity.name,
    value: entity.id,
  }
}